import React from 'react';
import { Field } from 'redux-form';
import { BooleanInput, LongTextInput, ReferenceArrayInput, SelectArrayInput, TextInput } from 'react-admin';
import { FormDataConsumer, required } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import CanViewInternalOnly from './Helpers/CanViewInternalOnly';
import CanViewPublishers from './Helpers/CanViewPublishers';
import ValidPublishers from './Helpers/ValidPublishers';

const ValidateRequired = required();

const styles = createStyles({
  internalOnly: {
    whiteSpace: 'nowrap'
  },
  name: {
    width: '100%'
  },
  publisher: {
    minWidth: 230
  }
});

type Props = {
  classes: any,
  permissions: any,
  resource: string,
  record: any
};

const CommonSettings = (props: Props) => (
  <div style={{ display: 'flex' }}>
    <div style={{ flex: 1, paddingRight: 15 }}>
      <FormDataConsumer>
        {({ formData, ...rest }) => formData && formData.code &&
          <span>ID: {formData && formData.code}<br /></span>
        }
      </FormDataConsumer>
      <Field
        component={BooleanInput}
        label="Active"
        name="active"
        source="active"
        style={{ width: '0' }} /><br />
      <Field
        className={props.classes.name}
        component={TextInput}
        label="Name *"
        name="name"
        source="name"
        validate={ValidateRequired} /><br />
      <Field
        component={LongTextInput}
        label="Description"
        name="description"
        source="description" /><br />
    </div>
    <div style={{ flex: 1, paddingLeft: 15 }}>
      <FormDataConsumer>
        {({ formData, ...rest }) => formData && formData.code && <br />}
      </FormDataConsumer>
      <FormDataConsumer>
        {({ formData, ...rest }) => CanViewInternalOnly(props.permissions) &&
          <div>
            <Field
              className={props.classes.internalOnly}
              component={BooleanInput}
              label="Internal/Admin Only"
              name="internal_only"
              source="internal_only"
              style={{ width: '0' }} /><br />
          </div>
        }
      </FormDataConsumer>
      <FormDataConsumer>
        {({ formData, ...rest }) => CanViewPublishers(formData) &&
          <div>
            <Field
              allowEmpty
              className={props.classes.publisher}
              component={ReferenceArrayInput}
              label="Publisher Owner (Visibility) *"
              name="publishers"
              record={props.record}
              reference="helpers/publisher_ids"
              resource={props.resource}
              sort={{ field: 'name', order: 'ASC' }}
              source="publishers"
              validate={ValidPublishers}
            >
              <Field
                component={SelectArrayInput}
                label="Publishers"
                name="publishers"
                source="publishers" />
            </Field><br />
          </div>
        }
      </FormDataConsumer>
    </div>
  </div>
);

export default withStyles(styles)(CommonSettings);



// WEBPACK FOOTER //
// ./src/views/Common/Partials/Settings.tsx